import CustomButton from "components/common/Button/CustomButton";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import { apiDeleteRequest } from "helpers/Requests";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { getParticipantCall } from "store/actions/participant.actions";
import { getUrlRole, selectedTabState } from "Utils/utils";

const DeleteFormModal = (props) => {
  const {
    open,
    setOpen,
    isUserGracePeriodOver,
    handleClose,
    role,
    uuid,
    refreshFormList,
  } = props;

  const dispatch = useDispatch();
  const {uuid: participantUUID} = useParams();
 
  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });

 const handleDelete = async () => {
  setRequest({ isRequested: true, isSuccess: false, isFailed: false });

  try {
    let url = "";

    if (role === "sil") {
      url = `/sil/home/form/delete-form/${uuid}`;
    } else {
      url = `/${getUrlRole()}/participant/delete-form/${uuid}`;
    }

    const response = await apiDeleteRequest(url, { form_uuid: uuid });

    if (response.status === 200) {
      toast.success("Form deleted successfully!");
      handleClose();
      refreshFormList();

      // Preserve the Forms tab (id: 4) after deletion
      if (participantUUID) {
        const currentTab = selectedTabState.get();
        if (currentTab && currentTab.id === 4) {
          selectedTabState.save(JSON.stringify(currentTab));
        } else {
          selectedTabState.save(JSON.stringify({ name: "Forms", id: 4, children: [] }));
        }
        dispatch(getParticipantCall({ participantUUID: participantUUID }));
      }
    } else {
      throw new Error("Failed to delete form");
    }
  } catch (error) {
    setRequest({ isRequested: false, isSuccess: false, isFailed: true });
    console.error("Failed to delete form:", error);
    toast.error("Failed to delete form. Please try again.");
  } finally {
    setRequest({ isRequested: false, isSuccess: false, isFailed: false });
  }
};

  const modalFooter = () => (
    <>
      <CustomButton
        showLoading={request.isRequested}
        isDisabled={request.isRequested || isUserGracePeriodOver}
        label='Yes, delete Form'
        clickHandler={handleDelete}
        variant='danger'
      />
      <CustomButton label='No, cancel changes' onClick={handleClose} />
    </>
  );

  return (
    <>
      <ModalSkeleton
        modalFooter={modalFooter()}
        isOpen={open}
        closeModal={() => setOpen(false)}
        cssClass='w-[35%]'
        title={"Delete Form"}
      >
        <div>
          <p className='text-gray-700'>
            Are you sure you want to delete this Form?
          </p>
          <p className="text-xs text-gray-500 mt-2">This action will be recorded in the audit log.</p>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default DeleteFormModal;
